import * as React from "react";
import { useState } from "react";
import { 
  Box, 
  Typography, 
  TextField,
  Button,
  Paper
} from "@mui/material";
import dayjs from "dayjs";
import ReportContent from "./ReportContent";

const Index = () => {
    const [selectedReport, setSelectedReport] = useState(null);
    const [startDate, setStartDate] = useState(dayjs().subtract(6, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));

    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };

    const handleReportSelect = (reportType) => {
        setSelectedReport(reportType);
    };

    return (
        <Box sx={{ flexGrow: 1, p: { xs: 1, md: 1.5 } }}>
            <Box sx={{ textAlign: "center", mb: 1 }}>
                <Typography
                    sx={{
                        fontSize: { xs: 16, md: 20 },
                        fontWeight: "bold",
                    }}
                >
                    Reports
                </Typography>
            </Box>

            {/* Date Selection and Report Buttons */}
            <Paper sx={{ p: 1, mb: 1.5 }}>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
                    {/* Date Range */}
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap", flex: 1 }}>
                        <Typography variant="body2" sx={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                            Date Range:
                        </Typography>
                        <TextField
                            type="date"
                            label="Start"
                            value={startDate}
                            onChange={handleStartDateChange}
                            size="small"
                            sx={{ minWidth: 120, maxWidth: 130 }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                style: { fontSize: "0.75rem", padding: "8px" }
                            }}
                        />
                        <TextField
                            type="date"
                            label="End"
                            value={endDate}
                            onChange={handleEndDateChange}
                            size="small"
                            sx={{ minWidth: 120, maxWidth: 130 }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                style: { fontSize: "0.75rem", padding: "8px" }
                            }}
                        />
                    </Box>

                    {/* Report Buttons */}
                    <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", justifyContent: "flex-end" }}>
                        <Button
                            variant={selectedReport === "averageCustomerCount" ? "contained" : "outlined"}
                            size="small"
                            onClick={() => handleReportSelect("averageCustomerCount")}
                            sx={{ fontSize: "0.7rem", py: 0.5, px: 1, minWidth: "auto" }}
                        >
                            Day Count
                        </Button>
                        <Button
                            variant={selectedReport === "averageCustomerTimeSlot" ? "contained" : "outlined"}
                            size="small"
                            onClick={() => handleReportSelect("averageCustomerTimeSlot")}
                            sx={{ fontSize: "0.7rem", py: 0.5, px: 1, minWidth: "auto" }}
                        >
                            2H Slot
                        </Button>
                        <Button
                            variant={selectedReport === "averageWaitingTime" ? "contained" : "outlined"}
                            size="small"
                            onClick={() => handleReportSelect("averageWaitingTime")}
                            sx={{ fontSize: "0.7rem", py: 0.5, px: 1, minWidth: "auto" }}
                        >
                            Wait Time
                        </Button>
                        <Button
                            variant={selectedReport === "detailedQueueReport" ? "contained" : "outlined"}
                            size="small"
                            onClick={() => handleReportSelect("detailedQueueReport")}
                            sx={{ fontSize: "0.7rem", py: 0.5, px: 1, minWidth: "auto" }}
                        >
                            Detailed
                        </Button>
                        <Button
                            variant={selectedReport === "lostCustomerStatistics" ? "contained" : "outlined"}
                            size="small"
                            onClick={() => handleReportSelect("lostCustomerStatistics")}
                            sx={{ 
                                fontSize: "0.7rem", 
                                py: 0.5, 
                                px: 1, 
                                minWidth: "auto",
                                ...(selectedReport === "lostCustomerStatistics" 
                                    ? { 
                                        backgroundColor: "error.main", 
                                        color: "white",
                                        "&:hover": { backgroundColor: "error.dark" }
                                    } 
                                    : { 
                                        color: "error.main", 
                                        borderColor: "error.main", 
                                        "&:hover": { borderColor: "error.dark", backgroundColor: "rgba(211, 47, 47, 0.08)" } 
                                    })
                            }}
                        >
                            LOST
                        </Button>
                    </Box>
                </Box>
            </Paper>

            {/* Report Content */}
            <Box sx={{ mt: 1.5 }}>
                <ReportContent 
                    selectedReport={selectedReport} 
                    startDate={dayjs(startDate)}
                    endDate={dayjs(endDate)}
                />
            </Box>
        </Box>
    );
};

export default Index;
